import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const ActivityModal = ({ modal, toggle, activity }) => {
  // Format date range
  const formatDate = (date) => {
    const d = new Date(date);
    if (isNaN(d)) return null; // Verifica si la fecha es inválida
  
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };
  
  const formatDateRange = (start, end) => {
    const startFormatted = formatDate(start);
    const endFormatted = formatDate(end);
  
    if (!startFormatted && !endFormatted) return "-"; // Ninguna fecha
    if (startFormatted && !endFormatted) return startFormatted;
    if (!startFormatted && endFormatted) return endFormatted;
  
    return startFormatted === endFormatted
      ? startFormatted
      : `${startFormatted} al ${endFormatted}`;
  };
  


  return (
    <Modal
      isOpen={modal}
      id="activity-modal"
      size="xs"
      className="border-0"
      modalClassName="modal fade zoomIn"
      backdrop="static"
      centered
    >
      <ModalHeader toggle={toggle}>
        {activity?.title || ""}
      </ModalHeader>
      <ModalBody>
        <div className="event-details">
          {/* Fecha de inicio y fin */}
          <ModalItem
            name="Fecha"
            iconClass={`${Icons.calendar}`}
            text={
              activity
                ? `${formatDateRange(
                  activity?.extendedProps?.start,
                  activity?.extendedProps?.end
                )}`
                : ""
            }
          />

          {/* Grupo de actividad */}
          <ActivityBadge
            name="Grupo"
            iconClass={`${Icons.persons}`}
            label="activity-group-tag"
            badge={activity?.extendedProps?.activity_group}
          />

          {/* Estado de la actividad */}
          <ActivityBadge
            name="Estado"
            iconClass="ri-checkbox-circle-line"
            label="activity-status-tag"
            badge={activity?.extendedProps?.activity_status}
          />

          {/* Prioridad de la actividad */}
          <ActivityBadge
            name="Prioridad"
            iconClass="ri-flag-line"
            label="activity-priority-tag"
            badge={activity?.extendedProps?.activity_priority}
          />

          {/* Tipo de actividad */}
          <ModalItem
            name="Tipo"
            iconClass="ri-file-list-line"
            text={
              activity?.extendedProps?.activity_type?.name
                ? activity.extendedProps.activity_type.name.toUpperCase()
                : "-"
            }
          />

          {/* Periodicidad */}
          <ModalItem
            name="Periodicidad"
            iconClass="ri-calendar-line"
            text={
              activity?.extendedProps?.periodicity?.name
                ? activity.extendedProps.periodicity.name.toUpperCase()
                : "-"
            }
          />

          {/* Responsable */}
          <ModalItem
            name="Responsable"
            iconClass="ri-user-line"
            text={
              activity?.extendedProps?.responsible?.name
                ? activity.extendedProps.responsible.name.toUpperCase()
                : activity?.extendedProps?.company?.name
                  ? activity.extendedProps.company.name.toUpperCase()
                  : "-"
            }
          />


          {/* Descripción */}
          <ModalDescription
            name="Descripción"
            iconClass="ri-discuss-line"
            text={
              activity?.extendedProps?.description
                ? activity.extendedProps.description
                  .toUpperCase()
                  .split(',')
                  .map((line, index) => <div key={index}>{line.trim()}</div>)
                : "-"
            }
          />

        </div>
      </ModalBody>

    </Modal>
  );
};

// Subcomponentes para simplificar el código y ajustar el formato
const ModalItem = ({ iconClass, text, name }) => (
  <div className="d-flex align-items-start mb-2">
    <div className="d-flex align-items-center flex-shrink-0" style={{ minWidth: '150px' }}>
      <i className={`${iconClass} text-muted fs-16`}></i>
      <span className="ms-2 text-muted">{name}</span>
    </div>
    <div className="flex-grow-1 ms-3">
      <h6 className="d-block fw-semibold mb-0">{text}</h6>
    </div>
  </div>
);

const ActivityBadge = ({ iconClass, label, badge, name }) => (
  <div className="d-flex align-items-start mb-2">
    <div className="d-flex align-items-center flex-shrink-0" style={{ minWidth: '150px' }}>
      <i className={`${iconClass} text-muted fs-16`}></i>
      <span className="ms-2 text-muted">{name}</span>
    </div>
    <div className="flex-grow-1 ms-3">
      <span className="d-block fw-semibold mb-0" id={label}>
        {badge ? (
          <span
            className="badge fs-11"
            style={{
              backgroundColor: badge.bgcolor || "",
              color: badge.txcolor || ""
            }}
          >
            <i className={`align-middle me-2 ${badge.icon || ""}`}></i>
            {badge.name.toUpperCase() || ""}
          </span>
        ) : "-"}
      </span>
    </div>
  </div>
);

const ModalDescription = ({ iconClass, text, name }) => (
  <div className="d-flex align-items-start mb-3">
    <div className="d-flex align-items-center flex-shrink-0" style={{ minWidth: '150px' }}>
      <i className={`${iconClass} text-muted fs-16`}></i>
      <span className="ms-2 text-muted">{name}</span>
    </div>
    <div className="flex-grow-1 ms-3">
      <p className="d-block text-muted mb-0">{text}</p>
    </div>
  </div>
);

ActivityModal.propTypes = {
  modal: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  activity: PropTypes.object,
};

export default ActivityModal;
